import { getIconForApp } from "../hub/hubIcons.js";

export function resolveAppIconKey(app) {
  return String(app?.iconKey || app?.icon || app?.appKey || app?.id || "").trim();
}

export function getLauncherIconForApp(app) {
  const key = String(app?.appKey || app?.id || "").trim().toLowerCase();
  if (!key) return null;
  return getIconForApp(key);
}

